import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Table, Button, Badge, ListGroup, Modal } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import StatisticsWidget from "../../Components/StatisticsWidget";
import { getProductList, getSupplierDashboard } from "../../redux/actions/ManageProductActions";
import { getEnquiryList } from "../../redux/actions/EnquiryActions";
import RoundedPagination from "../../Components/Paginate";
import { encodeIdToBase64, getDisplayDateTimeFormat } from "../../util/generalUtills";
import useDebounce from "../../hooks/useDebounce";
import { profileDetails } from "../../redux/actions/SupplierActions";
import profilePic from "../../assets/images/users/user-1.jpg";
import pdfUrl from "../../assets/pdf/AFFIDAVIT_Supplier_Franchise_CM Yuva Web Terms.pdf";
import axios from "axios";
import swal from 'sweetalert2';


const Dashboard = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const {
        AuthReducer: { auth, isAuthenticated, errors },
        productReducer: {
            productLists,
            dashboard,
        },
        enquiryReducer: {
            enquiryLists,
            enquiryCount,
        },
        supplierReducer: { supplierDetails },
    } = useSelector((state) => state);

    const profileFields = [
        supplierDetails?.business_name,
        supplierDetails?.designation,
        supplierDetails?.total_experience,
        supplierDetails?.sectors?.length ? supplierDetails?.sectors : null,
        supplierDetails?.industries?.length ? supplierDetails?.industries : null,
        supplierDetails?.type,
        supplierDetails?.address,
        supplierDetails?.state,
        supplierDetails?.city,
        supplierDetails?.pincode,
        supplierDetails?.website_url,
        supplierDetails?.key_points?.length ? supplierDetails?.key_points : null,
        supplierDetails?.additional_info,
        supplierDetails?.bank_name,
        supplierDetails?.bank_ifsc_code,
        supplierDetails?.bank_branch_name,
        supplierDetails?.bank_account_number,
        supplierDetails?.bank_person_name,
        supplierDetails?.created_at,
    ];
    const totalFields = profileFields.length;
    const filledFields = profileFields.filter(
        (field) =>
            field !== null &&
            field !== undefined &&
            (typeof field === 'string' ? field.trim() !== '' : true)
    ).length;

    const percentage = Math.round((filledFields / totalFields) * 100);
    const [keyPoints, setKeyPoints] = useState([]);
    useEffect(() => {
        const initialKeyPoints = JSON.parse(supplierDetails?.key_points || "[]");
        setKeyPoints(Array.isArray(initialKeyPoints) ? initialKeyPoints : []);
    }, [supplierDetails]);

    const [editProductId, setEditProductId] = useState(null);
    const [productListing, setProductListing] = useState(null);
    const [afidavitModal, setAfidavitModal] = useState(false);
    const [afidavitCheck, setAfidavitCheck] = useState(false);
    const [productID, setProductID] = useState(null);
    const [page, setPage] = useState(1);
    const [paginate, setPaginate] = useState(1);
    const [total, setTotal] = useState("");
    const [search, setSearch] = useState("");
    const [sort, setSort] = useState('desc');
    const [err, setErr] = useState({});
    const indexOfLastItem = (page + 1) * paginate;
    const indexOfFirstItem = indexOfLastItem - paginate;

    useEffect(() => {
        if (productLists) {
            setProductListing(productLists?.data);
            setPage(productLists?.current_page);
            setTotal(productLists?.total);
            setPaginate(productLists?.per_page);
        }
    }, [productLists])

    const fetchProductList = useCallback(() => {
        if (auth?.token) {
            dispatch(getProductList(auth.token, paginate, page, search, sort));
            dispatch(profileDetails(auth?.token));
        }
    }, [auth, paginate, page, search, sort, dispatch]);

    useDebounce(fetchProductList, 500, [auth, paginate, page, search, sort]);

    useEffect(() => {
        if (supplierDetails?.affidavit_check == 0) {
            setAfidavitModal(true);
        }
    }, [supplierDetails]);
    useEffect(() => {
        if (!isAuthenticated) {
            dispatch(logout());
            navigate('/login')
        }
    }, [auth]);

    useEffect(() => {
        if (errors) {
            if (errors?.status == 401) {
                dispatch(logout())
                toast.error(errors?.data?.message);
                navigate('/login');
                window.location.reload();
            }
        }
    }, [errors])

    const handlePaginateChange = (e) => {
        const value = e.target.value === "All" ? total : parseInt(e.target.value);
        setPaginate(value);
        setPage(1);
    };

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };

    useEffect(() => {
        dispatch(getSupplierDashboard(auth?.token));
    }, []);

    const [enqTotal, setEnqTotal] = useState(0);
    const [enqPage, setEnqPage] = useState(1);
    const [enqpaginate, setEnqPaginate] = useState(10);
    const [enqSearch, setEnqSearch] = useState("");
    const [enqSort, setEnqSort] = useState('desc');
    const [enquiriesListing, setEnquiriesListing] = useState([]);
    const enqIndexOfLastItem = (enqPage + 1) * enqpaginate;
    const enqIndexOfFirstItem = enqIndexOfLastItem - enqpaginate;

    useEffect(() => {
        if (enquiryLists) {
            setEnquiriesListing(enquiryLists?.data);
            setEnqPage(enquiryLists?.current_page);
            setEnqTotal(enquiryLists?.total);
            setEnqPaginate(enquiryLists?.per_page);
        }
    }, [enquiryLists])
    const fetchEnquiryList = useCallback(() => {
        if (auth?.token) {
            dispatch(getEnquiryList(auth.token, enqpaginate, enqPage, enqSearch, enqSort));
        }
    }, [auth, enqpaginate, enqPage, enqSearch, enqSort, dispatch]);

    useDebounce(fetchEnquiryList, 500, [auth, enqpaginate, enqPage, enqSearch, enqSort]);

    const enqHandlePaginateChange = (e) => {
        const value = e.target.value === "All" ? enquiryCount : parseInt(e.target.value);
        setEnqPaginate(value);
        setEnqPage(1);
    };

    const enqHandleSearchChange = (event) => {
        setEnqSearch(event.target.value);
    };
    const handleAfidavitSubmit = async (event) => {
        event.preventDefault();
        if (!afidavitCheck) {
            setErr({
                ...err,
                affidavit_check: "Please Check Before Submit"
            });
            return true;
        }

        const affidavitData = {
            supplier_id: auth?.id,
            affidavit_check: afidavitCheck ? 1 : 0,
        };
        await axios
            .post('api/supplier/submit-affidavit', affidavitData, {
                headers: {
                    Authorization: `Bearer ${auth?.token}`,
                },
            })
            .then((res) => {
                swal.fire({
                    show: true,
                    title: "Well done!",
                    text: res?.data?.message,
                    icon: "success",
                    showConfirmButton: false,
                    timer: 1500,
                });
                setAfidavitModal(false);
            })
            .catch((err) => {
                console.log(err)
                swal.fire({
                    show: true,
                    title: "Something went Wrong!",
                    text: err?.response.message,
                    icon: "error",
                    showConfirmButton: false,
                    timer: 1500,
                });
            });


    };
    return (
        <>
            <PageTitle
                breadCrumbItems={[
                    { label: "Dashboard", path: "/", active: true },
                ]}
                title={"Dashboard"}
            />
            <Row>
                <Col md={7}>
                    <Row>
                        <Col md={6}>
                            <a href={`/Manage-Product`}>
                                <StatisticsWidget
                                    variant="primary"
                                    counterOptions={{
                                        prefix: "",
                                    }}
                                    description="Total Products"
                                    stats={dashboard?.productCount}
                                    icon="fe-shopping-cart"
                                />
                            </a>
                        </Col>
                        <Col md={6}>
                            <a href={`/Enquiries`}>
                                <StatisticsWidget
                                    variant="info"
                                    description="Total Enquiry"
                                    stats={dashboard?.enquiriesCount}
                                    counterOptions={{
                                        suffix: "",
                                        decimals: 0,
                                    }}
                                    icon="fe-bar-chart-line-"
                                />
                            </a>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Body>
                                    <div className="mb-2">
                                        <Row>
                                            <Col lg={3}>
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        type="search"
                                                        placeholder="Search..."
                                                        className="form-control ms-1"
                                                        autoComplete="off"
                                                        value={enqSearch}
                                                        onChange={enqHandleSearchChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg={9}>
                                                <div className="d-flex justify-content-end align-items-center">
                                                    <div className="button-list">
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    <div>
                                        <Table className="mb-0 table-sm" responsive striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>Sr No.</th>
                                                    <th>Name</th>
                                                    <th>Mobile</th>
                                                    <th>Email</th>
                                                    <th>Products</th>
                                                    <th>Last Note</th>
                                                    <th>Enquired On</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {enquiriesListing?.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="6">No data found</td>
                                                    </tr>
                                                ) : (
                                                    enquiriesListing?.map((item, index) => (
                                                        <tr key={item.id}>
                                                            <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                                                            <td>{item?.user?.name}</td>
                                                            <td>{item?.user?.mobile}</td>
                                                            <td>{item?.user?.email}</td>
                                                            <td>{item?.products?.map((product, index) => (
                                                                <span className="badge bg-primary me-1">{product?.name}</span>
                                                            )
                                                            )}
                                                            </td>
                                                            <td>{item?.notes?.length > 0 && (
                                                                <>
                                                                    <span className="me-1"><strong>Title : </strong> {item?.notes[0]?.title}</span><br />
                                                                    <span className="me-1"><strong>Disposition : </strong> {item?.notes[0]?.disposition}</span><br />
                                                                    <span className="me-1"><strong>Description : </strong> {item?.notes[0]?.note}</span>
                                                                </>
                                                            )}
                                                            </td>
                                                            <td>{getDisplayDateTimeFormat(item?.created_at)}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>

                                    <div className="mt-3 d-lg-flex align-items-center text-center pb-1">
                                        <div className="d-inline-block me-3">
                                            <label className="me-1">Display:</label>
                                            <select className="form-select d-inline-block w-auto" onChange={enqHandlePaginateChange}>
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        </div>
                                        <div class="d-inline-block me-3">
                                            <label class="me-1">Short :</label>
                                            <select class="form-select d-inline-block w-auto" onChange={(e) => setEnqSort(e.target.value)}>
                                                <option value="asc">Ascending</option>
                                                <option value="desc">Descending</option>
                                            </select>
                                        </div>
                                        <span className="me-3">Page <strong>{enqPage}</strong> of <strong>{Math.ceil(enqTotal / enqpaginate)}</strong> </span>
                                        <RoundedPagination currentPage={enqPage} totalPages={Math.ceil(enqTotal / enqpaginate)} onPageChange={(pageNumber) => setEnqPage(pageNumber)} />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={12}>
                            <Card className="shadow-lg rounded text-center">
                                {/* <h5 className="" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Supplier Details</h5> */}
                                <h5 className="mt-3" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{supplierDetails?.name}</h5>
                                <Card.Body>
                                    <img
                                        src={
                                            supplierDetails?.profile_image
                                                ? `https://msmesupplier.s3.ap-south-1.amazonaws.com/${supplierDetails.profile_image}`
                                                : profilePic
                                        }
                                        alt="Supplier"
                                        className="img-fluid rounded-circle mb-3"
                                        style={{
                                            width: '100px',
                                            height: '100px',
                                            objectFit: 'cover',
                                            border: '4px solid #ddd',
                                        }}
                                    />
                                    {/* <h4 className="font-weight-bold mb-2">{supplierDetails?.name}</h4> */}
                                    <div class="text-center mb-4">
                                        <div>
                                            <Button className="btn btn-primary btn-sm"><a href={`/supplier/${encodeIdToBase64(supplierDetails?.id)}`} className="text-white">View Public Profile</a></Button>
                                        </div>
                                    </div>
                                    <div class="progress" style={{ height: "20px" }}>
                                        <div
                                            class="progress-bar"
                                            role="progressbar"
                                            style={{ width: `${percentage}%`, backgroundColor: (percentage >= 100) ? '#4caf50' : '' }}
                                            aria-valuenow={percentage}
                                            aria-valuemin="0"
                                            aria-valuemax="100">Profile Completed {percentage}%</div>
                                    </div>
                                    <div className="mt-3">
                                        <Badge bg={supplierDetails?.approved == 1 ? "success" : "danger"}>{supplierDetails?.approved == 1 ? 'Approved' : 'Unapproved'}</Badge>
                                    </div>
                                    <ListGroup variant="flush">
                                        {[
                                            { label: 'Business name', value: supplierDetails?.business_name },
                                            { label: 'Designation', value: supplierDetails?.designation },
                                            { label: 'Total Experience', value: supplierDetails?.total_experience ? `${supplierDetails?.total_experience} year` : '' },
                                            {
                                                label: 'Sector', value: supplierDetails?.sectors?.map((sec) => sec?.sector?.name).join(', ')
                                            },
                                            {
                                                label: 'Industries', value: supplierDetails?.industries?.map((ind) => ind?.industry?.name).join(' , ')
                                            },
                                            { label: 'Type', value: supplierDetails?.type },
                                            { label: 'Address', value: supplierDetails?.address },
                                            { label: 'State', value: supplierDetails?.state },
                                            { label: 'City', value: supplierDetails?.city },
                                            { label: 'Pincode', value: supplierDetails?.pincode },
                                            { label: 'Website URL', value: supplierDetails?.website_url },
                                            {
                                                label: 'Key Points', value: keyPoints?.map((ind) => ind).join(`<br/>`)
                                            },
                                            { label: 'Additional Information', value: supplierDetails?.additional_info },
                                            { label: 'Bank Name', value: supplierDetails?.bank_name },
                                            { label: 'Bank Ifsc Code', value: supplierDetails?.bank_ifsc_code },
                                            { label: 'Bank Branch Name', value: supplierDetails?.bank_branch_name },
                                            { label: 'Bank Account Number', value: supplierDetails?.bank_account_number },
                                            { label: 'Bank Person Name', value: supplierDetails?.bank_person_name },
                                            { label: 'Registered At', value: getDisplayDateTimeFormat(supplierDetails?.created_at) },
                                        ].map((item, index) => (
                                            <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                                                <strong>{item.label}:</strong>
                                                <span dangerouslySetInnerHTML={{ __html: item.value }}></span>
                                            </ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
                <Modal show={afidavitModal} backdrop="static" keyboard={false} centered>
                    <Modal.Header>
                        <Modal.Title>Important Notice for Suppliers</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div >
                            <p className=" fw-bold" >To continue your registration and participation in the *CM Yuva Udyami Vikas Abhiyan, you are required to **read and accept the updated Terms & Conditions*.</p>
                            <p className=" fw-bold" > ✅ *Accepting the Terms & Conditions is mandatory* for your continued listing and access on the Supplier Portal.</p>
                            <p className=" fw-bold" > ❗ *Failure to accept* will result in *discontinuation of your registration* on the portal.</p>
                            <p className=" fw-bold" >Please review the Terms & Conditions carefully before proceeding.</p>
                            <input
                                type="checkbox"
                                checked={afidavitCheck}
                                name="afidavitCheck"
                                onChange={() => setAfidavitCheck(!afidavitCheck)}
                                className="me-2 "
                            />
                            <a href={pdfUrl} target="_blank"  >
                                <span className="text-primary">
                                    I hereby agree and submit my self-declaration.
                                </span></a>
                            {err?.affidavit_check ? <div><small className="text-danger">{err?.affidavit_check}</small> </div> : null}
                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={(e) => handleAfidavitSubmit(e)}>
                            Submit
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Row>

            {/* <Row>
        <Col>
            <Card>
                <Card.Body>
                    <div className="mb-2">
                        <Row>
                            <Col lg={3}>
                                <div className="d-flex align-items-center">

                                    <input
                                        type="search"
                                        placeholder="Search..."
                                        className="form-control ms-1"
                                        autoComplete="off"
                                        value={search}
                                        onChange={handleSearchChange}
                                    />


                                </div>
                            </Col>
                            <Col lg={9}>
                                <div className="d-flex justify-content-end align-items-center">
                                    <div className="button-list">
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div>
                        <Table className="mb-0 table-sm" responsive="sm" striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Sr No.</th>
                                    <th>Name</th>
                                    <th>Price</th>
                                    <th>Video URL</th>
                                    <th>Image</th>
                                    <th>Manufactured By</th>
                                    <th>Location</th>
                                    <th>Description</th>
                                    <th>Status</th>
                                    <th>Registered At</th>
                                </tr>
                            </thead>
                            <tbody>
                                {productListing?.length === 0 ? (
                                    <tr>
                                        <td colSpan="14">No data found</td>
                                    </tr>
                                ) : (
                                    <>
                                        {productListing?.map((item, index) => {
                                            return (
                                                <tr key={item.id}>
                                                    <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                                                    <td>{item?.name}</td>
                                                    <td>{item?.price}</td>
                                                    <td><a href={item?.video_url} target="_blank" rel="noopener noreferrer"> View Video </a> </td>
                                                    <td>
                                                        <img
                                                            src={`https://msmesupplier.s3.ap-south-1.amazonaws.com/${item?.image}`}
                                                            alt={item?.name}
                                                            style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                        />
                                                    </td>
                                                    <td>{item?.manufactured_by}</td>
                                                    <td>{item?.location}</td>
                                                    <td>{item?.description}</td>
                                                    <td>
                                                        {item?.status == "0" ? (
                                                            <Badge className={"bg-danger"}>Unapproved</Badge>
                                                        ) : (
                                                            <Badge className={"bg-success"}>Approved</Badge>
                                                        )}
                                                    </td>
                                                    <td>{getDisplayDateTimeFormat(item?.createdAt)}</td>
                                                </tr>
                                            );
                                        })}
                                    </>
                                )}
                            </tbody>
                        </Table>

                    </div>
                    <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                        <div class="d-inline-block me-3">
                            <label class="me-1">Display :</label>
                            <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <div class="d-inline-block me-3">
                            <label class="me-1">Short :</label>
                            <select class="form-select d-inline-block w-auto" onChange={(e) => setSort(e.target.value)}>
                                <option value="asc">Ascending</option>
                                <option value="desc">Descending</option>
                            </select>
                        </div>
                        <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(total / paginate)}</strong> </span>
                        <RoundedPagination currentPage={page} totalPages={Math.ceil(total / paginate)} onPageChange={(pageNumber) => setPage(pageNumber)} />
                    </div>
                </Card.Body>
            </Card>
        </Col>
    </Row> */}
        </>
    );
};

export default Dashboard;
